module.exports = __webpack_public_path__ + "img/st.f48819e9.svg";